module.exports = __webpack_public_path__ + "static/media/BlackCircleTransition.faa5fda4.svg";